export enum ExportItemState {
  DEFAULT = 'default',
  PROCESSING = 'processing',
  SUCCESS = 'success',
}

export interface ExportMenuItemTitles {
  default: string;
  processing: string;
  success: string;
}

export interface ExportMenuItemProps {
  defaultIcon: string;
  titles: ExportMenuItemTitles;
  description: string;
  state: ExportItemState;
  onClick: () => void;
}
